import React, { useState, useEffect, ChangeEvent } from "react";
import { Input } from "@chakra-ui/react";
import { UseFormRegister, UseFormSetValue } from "react-hook-form";
interface IAddressInput {
  name: string;
  value: string;
  senderAddress: string;
  isDisabled: boolean;
  placeholder: string;
  onChange: (value: string) => void;
  register: UseFormRegister<any>;
  setValue: UseFormSetValue<any>;
}

const AddressInput: React.FC<IAddressInput> = ({
  name,
  value,
  senderAddress,
  isDisabled,
  placeholder,
  onChange,
  register,
  setValue,
}: IAddressInput) => {
  const [sameAsSender, setSameAsSender] = useState(false);

  const receiverValidator = register(name);

  useEffect(() => {
    if (value === "") {
      setSameAsSender(false);
    }
  }, [value]);

  return (
    <>
      <Input
        borderRadius="0px"
        name={name}
        value={value}
        disabled={isDisabled}
        readOnly={sameAsSender === true}
        placeholder={placeholder}
        onChange={(event: ChangeEvent<HTMLInputElement>) => {
          receiverValidator.onChange(event); // form validation
          onChange(event.target.value); // data passing
        }}
        onBlur={receiverValidator.onBlur}
        ref={receiverValidator.ref}
      />

      <label
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          cursor: isDisabled || !senderAddress ? "not-allowed" : "pointer",
          opacity: isDisabled || !senderAddress ? 0.5 : 1,
        }}
      >
        <input
          type="checkbox"
          checked={sameAsSender}
          disabled={isDisabled || !senderAddress}
          onChange={(e) => {
            setSameAsSender(e.target.checked);
            if (e.target.checked) {
              setValue(name, senderAddress, { shouldValidate: true });
              onChange(senderAddress);
            }
          }}
          style={{ accentColor: "#171717" }}
        />
        I want to send funds to my address
      </label>
    </>
  );
};

export default AddressInput;
